<template>
  <section :class="{ 'drag-over': isDragOver }" @dragover="onDragover" @dragleave="onDragleave" @drop="onDrop">
    <slot />
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const emit = defineEmits<{
  (e: 'file-dropped', files: File[]): void;
}>();
const isDragOver = ref(false);
const getDroppedFiles = (event: DragEvent) => {
  let files: File[] = [];

  if (event.dataTransfer!.files && event.dataTransfer!.files.length > 0) {
    files = Array.from(event.dataTransfer!.files, (file: File) => file);
  } else if (event.dataTransfer!.items && event.dataTransfer!.items.length > 0) {
    files = Array.from(event.dataTransfer!.items, (item: DataTransferItem) => item.getAsFile()!);
  }

  return files.filter((file) => file instanceof File);
};
const onDragover = (e: DragEvent) => {
  // eslint-disable-next-line no-param-reassign
  e.dataTransfer!.dropEffect = 'copy';
  isDragOver.value = true;
};
const onDragleave = () => {
  isDragOver.value = false;
};
const onDrop = (e: DragEvent) => {
  e.preventDefault();
  isDragOver.value = false;

  const files = getDroppedFiles(e);

  if (files.length > 0) {
    emit('file-dropped', files);
  }
};
</script>
